module.exports = __webpack_public_path__ + "img/pdf_logo_medium.cd0319be.png";